module.exports = __webpack_public_path__ + "static/media/hamburger.4988d233.svg";